import { Divider } from '@mui/material';
import { isNotNullOrUndefined } from '@weft/utils';
import { get } from 'lodash';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { VayuTextField } from '../../../../../../../components/design/vayu-theme-components/VayuTextField';
import { useFormErrorNotificationContext } from '../../../../../../../contexts/form-error-notification-context/form-error-notification-context';
import { useChargeContext } from '../../../charge-context';
import type { NewPlanForm } from '../../../CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../../CreatePlanForm/create-plan-form-types/plan-input-form';
import type { CreatePlanTab } from '../../../CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { CREATE_PLAN_TABS } from '../../../CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { ChargeEditDrawerContentItemOptional } from '../ChargeEditDrawerContentItemOptional';
import { AsCreditSelector } from '../components/AsCreditSelector';
import { ProductErpIdSelector } from '../components/ProductErpIdSelector';

export const OneTimeChargeEditDrawerContent: React.FC = () => {
  const { itemIndex: productIndex } = useChargeContext();
  const { registerErrorField } = useFormErrorNotificationContext<PlanInputForm, CreatePlanTab>();
  const { register, formState: { errors } } = useFormContext<PlanInputForm, NewPlanForm>();

  const registerDescription = register(`fixedProducts.${productIndex}.variants.0.description`);
  registerErrorField(registerDescription.name, CREATE_PLAN_TABS.serviceFees);

  return (
    <div>
      <div className="flex flex-col gap-y-6">
        <ChargeEditDrawerContentItemOptional
          fieldPath={registerDescription.name}
          label="Add description"
        >
          <VayuTextField
            {...registerDescription}
            fullWidth
            focused
            placeholder="Add a description"
            multiline
            error={isNotNullOrUndefined(get(errors, registerDescription.name))}
          />
        </ChargeEditDrawerContentItemOptional>

        <ProductErpIdSelector />

        <Divider />

        <AsCreditSelector />

        <Divider />
      </div>
    </div>
  );
};